"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const MainNav_1 = require("./MainNav");
const Drawer_1 = require("./Drawer");
class Layout extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.closeDrawer = () => {
            this.props.onDrawerClose();
            this.setState({ drawerOpen: false });
        };
        this.openDrawer = () => {
            this.props.onDrawerOpen();
            this.setState({ drawerOpen: true });
        };
        this.state = {
            drawerOpen: props.drawerOpen,
        };
    }
    componentDidMount() {
        document.body.scrollTop = 0;
    }
    render() {
        const { breadcrumbs, children, drawerContent, drawerHeaderTitle, elementRight, loading, mainNavTitle } = this.props;
        const { drawerOpen } = this.state;
        return (React.createElement("div", { className: "layout" },
            React.createElement(MainNav_1.MainNav, { title: mainNavTitle, breadcrumbs: breadcrumbs, elementRight: elementRight, loading: loading, onClickMenuButton: this.openDrawer }),
            React.createElement(Drawer_1.Drawer, { open: drawerOpen, title: drawerHeaderTitle, onClose: this.closeDrawer }, drawerContent),
            children));
    }
}
Layout.defaultProps = {
    breadcrumbs: [],
    drawerOpen: false,
    elementRight: null,
    mainNavTitle: '',
    loading: false,
    onDrawerClose: () => null,
    onDrawerOpen: () => null,
};
exports.Layout = Layout;



//////////////////
// WEBPACK FOOTER
// ./src/components/Layout.tsx
// module id = 358
// module chunks = 0